import { useRef, useState } from "react";

const useAudioRecorder = (onTranscription) => {
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mimeType = MediaRecorder.isTypeSupported('audio/webm')
        ? 'audio/webm'
        : MediaRecorder.isTypeSupported('audio/mp4')
        ? 'audio/mp4'
        : 'audio/ogg';
      const options = { mimeType };
      mediaRecorderRef.current = new MediaRecorder(stream, options);
      audioChunksRef.current = [];
      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };
      mediaRecorderRef.current.onstop = async () => {
        if (audioChunksRef.current.length === 0) {
          return;
        }
        const audioBlob = new Blob(audioChunksRef.current, { type: mimeType });
        const formData = new FormData();
        formData.append("file", audioBlob, "recording.webm");
        try {
          const res = await fetch("https://stream.gizmott.com/chat-agent/transcribe", {
            method: "POST",
            body: formData,
          });
          if (!res.ok) {
            throw new Error(`Transcription failed: ${res.status} ${res.statusText}`);
          }
          const data = await res.json();
          if (data?.text && data.text.trim()) {
            onTranscription(data.text.trim());
          } else if (data?.transcription && data.transcription.trim()) {
            onTranscription(data.transcription.trim());
          }
        } catch (error) {
          // Transcription error silently ignored
        }
      };
      mediaRecorderRef.current.onerror = (event) => {};
      mediaRecorderRef.current.onstart = () => {};
      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (err) {
      // Microphone access denied silently ignored
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      if (mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
      }
      if (mediaRecorderRef.current.stream) {
        mediaRecorderRef.current.stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      setIsRecording(false);
    }
  };

  return { isRecording, startRecording, stopRecording };
};

export default useAudioRecorder;